<template>
    <div class="form-group">
        <div class="custom-control custom-checkbox pl-0">
            <!-- Input -->
            <input type="checkbox" class="custom-control-input" :id="id" :name="name" v-model="inputVal" :checked="checked" />

            <!-- Label -->
            <label class="custom-control-label d-block" :for="id">
                <!-- Price -->
                <strong class="float-right" v-if="price !== undefined">
                    {{ price | formatPrice }}
                    &euro;
                </strong>

                <!-- Icon -->
                <i :class="icon + ' font-weight-400'" v-if="icon" />

                <!-- Label -->
                {{ label }}

                <!-- Required -->
                <span class="required" v-if="required">*</span>

                <!-- Subname -->
                <small class="d-block" v-if="subname">
                    {{ subname }}
                </small>

                <!-- Code -->
                <code class="d-block" v-if="code">
                    <small>
                        <span v-if="codeLabel">
                            {{ codeLabel }}:
                        </span>
                        <span v-if="! codeLabel">
                            Code:
                        </span>

                        {{ code }}
                    </small>
                </code>

                <!-- Help text -->
                <small class="form-text text-muted mt-0" v-if="helpText">
                    {{ helpText }}
                </small>
            </label>
        </div>

        <!-- Invalid feedback -->
        <div class="invalid-feedback" v-if="errors && name in errors">
            {{ errors[name] }}
        </div>
    </div>

</template>

<script>
    export default {
        props: ['label', 'icon', 'price', 'subname', 'code', 'codeLabel', 'name', 'value', 'required', 'helpText', 'errors', 'checked'],
        data() {
            return {
                id: null,
            }
        },
        mounted() {
            // Set id
            this.id = 'input_' + this.randomID()
        },
        computed: {
            inputVal: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            }
        },
        methods: {
            randomID() {
                return Math.random().toString(36).substr(2, 9)
            }
        },
        watch: {}
    }
</script>
